<div class="modal-body">
  <div class="row p-3 mx-0">
    <div class="col-sm-12 text-center">
      <p class="text-center">
        Do you really want to <b>Delete</b> this Template.
      </p>
      <button class="btn btn-info mx-1" (click)="close()">Cancel</button>
      <button class="btn btn-danger mx-1" (click)="delete()">Delete</button>
    </div>
  </div>
</div>
